<template>
    <textarea
        class="py-2 px-4 border border-main-600 focus:outline-none focus:border-primary-600 w-full"
        :value="resolvedValue"
        @input="inputHandler"
        @change="changeHandler"
        v-bind="$attrs"
        :rows="getRows"
    ></textarea>
</template>

<script>
    import EvInput from "./EvInput";

    export default {
        name: "EvTextarea",
        extends: EvInput,
        props:{
            value: { default: undefined },
            modelValue: { default: undefined },
            autosize:{
                type:Object,
                default(){
                    return {
                        min:0,
                        max:0
                    }
                }
            }
        },
        methods :{
            inputHandler (e) {
                this.emitValue(e.target.value);
            }
        },
        computed: {
            getRows() {
                if(!this.resolvedValue){
                    return 0;
                }
                let count = String(this.resolvedValue).split("\n").length;
                if( !this.autosize.min || !this.autosize.max ){
                    return count;
                }
                if(count <= this.autosize.min){
                    return this.autosize.min;
                }else if(count <= this.autosize.max){
                    return count;
                }else{
                    return this.autosize.max;
                }
            }
        }
    }
</script>

<style scoped>

</style>
